import React, { useEffect, useState } from 'react';
export function OfferBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 30,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          minutes,
          seconds
        } = prev;
        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 0;
          seconds = 0;
        }
        return {
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="bg-deco-brick text-white py-2 px-4" data-id="element-128" data-mp="5e4mcl4wolec">
      <div className="flex items-center justify-center gap-2.5 flex-wrap text-[11px] sm:text-xs font-semibold tracking-wide" data-id="element-129" data-mp="ac63h0iruan6">
        <span className="uppercase tracking-[0.15em]" data-id="element-130" data-mp="3shj38m4q9hzm">Oferta especial</span>
        <span className="text-white/50" data-id="element-131" data-mp="1b88f7qb9dgq">·</span>
        <span className="text-white/85 font-medium" data-id="element-132" data-mp="1ayfpcdvss7c">Termina en</span>
        <span className="font-mono tabular-nums bg-white/20 rounded px-2 py-0.5" data-id="element-133" data-mp="qyk3ty7nbfvr">
          {pad(timeLeft.minutes)}:{pad(timeLeft.seconds)}
        </span>
      </div>
    </div>;
}